/**********************************************************************************************
* OntarioTECK VBA Developers
* Developed by Gustavo Miller
* Date created : 2026-04-24 10:06:47.973
*
* Location: D:\Acorns and Oaks (AAO)\AAO\
* Filename: \Source\about.ts
*
**********************************************************************************************/
import { implementPopover, ConfigurePopover } from "./utilities/popUtils.js"
import { AOCookieBuilder } from "./types/cookies.helper.js";

function initConfetti() {
    const jsConfetti = new JSConfetti();

    // If want to use the window version, we can do this instead:
    // const jsConfetti = new window.JSConfetti();

    const cookie = new AOCookieBuilder();
    const today = new Date().toDateString();

    if (
        cookie.options.confettiLoad &&
        !cookie.options.confettiShownToday
    ) {
        jsConfetti.addConfetti({
            confettiColors: [
                "#ff0a54",
                "#ff477e",
                "#ff7096",
                "#ff85a1",
                "#fbb1bd",
                "#f9bec7",
            ],
            emojis: ['🎉', '✨', '💥'],
            confettiRadius: 6,
            confettiNumber: 500,
        });

        cookie
            .setOption("confettiShownToday", true)
            .save();
    }
}

document.addEventListener("DOMContentLoaded", async (event) => {
    console.info(`About Me!`);

    console.log(`Implement Popover`);
    if (await implementPopover("About")) {
        ConfigurePopover(5000);
    }

    console.log(`Initialize Confetti`);
    initConfetti();
});